import { site } from '@yola/ws-sdk';
import saveSite from 'src/js/modules/saving/helpers/save-site';
import store from '../../../store';

const setAndSaveActivePageOnLocaleAdd = async ({ locale }, preventActivePageUpdateOnLocaleAdd) => {
  const state = store.getState();
  let activePageId = site.accessors.getActivePageId();

  if (!preventActivePageUpdateOnLocaleAdd) {
    activePageId = site.selectors.getHomePage(state, locale).id;
  }

  await site.operations.setActivePage(activePageId);
  saveSite();
};

export default setAndSaveActivePageOnLocaleAdd;
